// A request is current only within the same view scope and generation.
// invalidate also covers A -> B -> A navigation and component disposal.
export function createLatestReadGate() {
  let generation = 0
  return {
    begin(scope) { return { generation: ++generation, scope } },
    accepts(ticket, scope) { return ticket.generation === generation && ticket.scope === scope },
    invalidate() { generation += 1 },
  }
}
